import { ComponentPropsWithoutRef, useEffect, useRef } from 'react'

import { cn } from '@sparkai/utils'

interface MentionItemProps extends ComponentPropsWithoutRef<'div'> {
  isActive: boolean
}

export const MentionItem = ({ isActive, className = '', style, ...props }: MentionItemProps) => {
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (isActive) {
      ref.current?.scrollIntoView({ block: 'nearest' })
    }
  }, [isActive])

  return (
    <div
      ref={ref}
      className={cn(
        'mentionsItem',
        className,
        'flex cursor-pointer items-center gap-3 px-3 py-2 text-sm text-gray-900',
        {
          'bg-blue-50': isActive,
        }
      )}
      style={style}
      {...props}
    />
  )
}
